<template>
  <mdb-container class="gp-has-header">
      <mdb-card class="mb-4">
        <mdb-card-body>
          {{topMessage}}
        </mdb-card-body>
      </mdb-card>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import download from "js-file-download";

import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';

export default {
  name: "file-downloader",
  display: "File",
  order: 1,
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },

  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.getBlob("/groupFile/download/" + this.$route.params.id + "/?accessCode=" + this.$route.params.accessCode, {}).then(
      (res) => {
        let filename = "download.file"
        let cd = res.headers["content-disposition"]
        if (cd) {
          let parts = cd.split('"')
          if (parts.length >0) filename = parts[1]
        }
        this.topMessage = "Your file should have downloaded automatically. If not, please check your browser permissions."
        console.log("Filename is ", filename)
        download(res.data, filename)
      },
      (error) => {
        if (error.response.status == 403) this.topMessage = "You don't have access to that file."
        else this.topMessage = "Could not retrieve file."
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })

  },
  data() {
    return {
      topMessage: "Downloading....",
    };
  },

};

</script>
